import m from "../../geodata/es2015/continentsRussiaEuropeUltra";
window.am4geodata_continentsRussiaEuropeUltra = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/continentsRussiaEuropeUltra.js
// module id = null
// module chunks = 